export class PointType {
  static get Installation () {
    return 0
  }
  static get Repair () {
    return 1
  }
  static get Remove () {
    return 2
  }

  static getPointTypeName (PointType) {
    let tmpType = parseInt(PointType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 0:
        name = '新裝'
        break
      case 1:
        name = '維修'
        break
      case 2:
        name = '拆機'
        break
    }
    return name
  }
}
